var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewsieLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    overflow: "visible",
    preserveAspectRatio: "none",
    viewBox: "0 0 15.00001 11.99999",
    width: 15.00001,
    height: 11.99999,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0, 0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000009999999999843467, 0) rotate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      strokeWidth: 0,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      fill: "url(&quot"
    },
    d: "M10.83333,0h-9.16667c-0.91667,0 -1.66667,0.6 -1.66667,1.33333v9.33333c0,0.73333 0.75,1.33333 1.66667,1.33333h11.66667c0.91667,0 1.66667,-0.6 1.66667,-1.33333v-7.33333zM13.33333,10.66667h-11.66667v-9.33333h8.33333v2.66667h3.33333zM3.33333,9.33333h8.33333v-1.33333h-8.33333zM7.5,2.66667h-4.16667v1.33333h4.16667zM3.33333,6.66667h8.33333v-1.33333h-8.33333z",
    vectorEffect: "non-scaling-stroke"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "path-165098105059356",
    d: "M10.83333,0h-9.16667c-0.91667,0 -1.66667,0.6 -1.66667,1.33333v9.33333c0,0.73333 0.75,1.33333 1.66667,1.33333h11.66667c0.91667,0 1.66667,-0.6 1.66667,-1.33333v-7.33333zM13.33333,10.66667h-11.66667v-9.33333h8.33333v2.66667h3.33333zM3.33333,9.33333h8.33333v-1.33333h-8.33333zM7.5,2.66667h-4.16667v1.33333h4.16667zM3.33333,6.66667h8.33333v-1.33333h-8.33333z",
    vectorEffect: "non-scaling-stroke"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gradient-1650981050791673",
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    vectorEffect: "non-scaling-stroke"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "rgb(0,21,46)",
    stopOpacity: 1,
    vectorEffect: "non-scaling-stroke"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "rgb(0,179,239)",
    stopOpacity: 1,
    vectorEffect: "non-scaling-stroke"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewsieLogo);
export default __webpack_public_path__ + "static/media/newsieLogo.d20b6235167f72b1e9138c1a85f19e0c.svg";
export { ForwardRef as ReactComponent };